import {Alert, Box, Button, Typography, styled} from '@mui/material';

import {StyledCard} from 'presentation/components';

const DeactivateButton = styled(Button)(({theme}) => ({
	color: theme.palette.error.main,
}));

const AutoPaymentCardContainer = styled(StyledCard.Container)(() => ({
	flex: 1,
}));

const IconWrapper = styled(Box)(() => ({
	minWidth: 20,
	display: 'flex',
}));

const ErrorAlert = styled(Alert)(() => ({
	maxWidth: 320,
	textAlign: 'left',
}));

const ModalDescription = styled(Typography)(() => ({
	fontSize: 18,
	fontWeight: 600,
	textAlign: 'center',
}));

export {DeactivateButton, AutoPaymentCardContainer, IconWrapper, ErrorAlert, ModalDescription};
